import { SelectRegistrationTranslator } from 'src/translators'
import { useGetSelectRegistrationsQuery } from 'src/types/generated'

type Input = {
  projectId: string
  roomId: string
}

export const useGetSelectRegistrations = ({ projectId, roomId }: Input) => {
  const { loading, data, error, refetch } = useGetSelectRegistrationsQuery({
    variables: { projectId, roomId: Number(roomId) },
  })

  return {
    loading,
    selectRegistrations:
      data && data.selectRegistrations
        ? SelectRegistrationTranslator.toEntities(data.selectRegistrations)
        : [],
    error,
    refetch,
  }
}
